// API Configuration
// Usando URLs relativas - o nginx faz proxy para o backend
export const API_ENDPOINTS = {
  HEALTH: '/api/health',
  // App Luísa (28/09/2026): o painel Aplicativo, via server/routes/app-luisa.cjs.
  APP_TWMS_ACESSOS: '/api/app-twms/acessos',
  APP_TWMS_APROVAR: (id: number) => `/api/app-twms/acessos/${id}/aprovar`,
  APP_TWMS_RECUSAR: (id: number) => `/api/app-twms/acessos/${id}/recusar`,
  APP_TWMS_AVISO: '/api/app-twms/aviso',
  APP_TWMS_AVISO_NUMEROS: '/api/app-twms/aviso/numeros',
  APP_TWMS_AVISO_NUMERO: (id: number) => `/api/app-twms/aviso/numeros/${id}`,
  TRANSCRIBE: '/api/transcribe',
  TRANSCRIBE_CHUNK: '/api/transcribe-chunk',
  VIDEO_TRANSCRIPTION: '/api/video-transcription',
  UPLOAD_DOCUMENT: '/api/upload-document',
  UPLOAD_TEMP_FILE: '/api/upload-temp-file',
  TEMP_FILES: '/api/temp-files', // Listar arquivos temporários
  DELETE_TEMP_FILE: (filename: string) => `/api/temp-files/${filename}`, // Excluir arquivo temporário
  CHAT: '/api/chat',
  OPTIMIZE_PROMPT: '/api/optimize-prompt',
  
  // Endpoints de Persistência
  TRANSCRIPTIONS: '/api/transcriptions',
  RAG_DOCUMENTS: '/api/rag-documents',
  PROMPTS: '/api/prompts',
  CHAT_HISTORY: '/api/chat-history',
  CLEANUP: '/api/cleanup',
  
  // Endpoints Multi-Agentes
  AGENTS: '/api/agents',
  AGENT_CHAT: (agentId: string) => `/api/agents/${agentId}/chat`,
  AGENT_MESSAGES: (agentId: string) => `/api/agents/${agentId}/messages`,
  AGENT_SESSIONS: (agentId: string) => `/api/agents/${agentId}/sessions`,
  AGENT_RAG_ACCESS: (agentId: string) => `/api/agents/${agentId}/rag-access`,
  AGENT_STATISTICS: (agentId: string) => `/api/agents/${agentId}/statistics`,
  
  // Endpoints de Ferramentas
  TOOLS: '/api/tools',
  AGENT_TOOLS: (agentId: string) => `/api/agents/${agentId}/tools`,
  AGENT_TOOL_ENABLE: (agentId: string, toolId: string) => `/api/agents/${agentId}/tools/${toolId}/enable`,
  AGENT_TOOL_DISABLE: (agentId: string, toolId: string) => `/api/agents/${agentId}/tools/${toolId}/disable`,
  EVOLUTION_INSTANCES: '/api/evolution-instances',
  EVOLUTION_EXECUTE: '/api/tools/evolution/execute',
  
  // Endpoints de Compartilhamento
  AGENT_SHARE_ENABLE: (agentId: string) => `/api/agents/${agentId}/share/enable`,
  AGENT_SHARE_DISABLE: (agentId: string) => `/api/agents/${agentId}/share/disable`,
  AGENT_SHARE_STATS: (agentId: string) => `/api/agents/${agentId}/share/stats`,
  
  // Endpoints Públicos (sem auth)
  PUBLIC_AGENT: (shareToken: string) => `/api/public/agent/${shareToken}`,
  PUBLIC_SESSION: (shareToken: string) => `/api/public/chat/${shareToken}/session`,
  PUBLIC_CHAT: (shareToken: string) => `/api/public/chat/${shareToken}`,
  PUBLIC_MESSAGES: (sessionId: string) => `/api/public/chat/${sessionId}/messages`,

  // Endpoints do Mapa de Distribuição
  CEP: (cep: string) => `/api/cep/${cep}`,
  MAPA_ANALYZE_FILE: '/api/analyze-file-mapping',
  MAPA_UPLOAD_CLIENTES: '/api/mapa/upload-clientes',
  MAPA_UPLOAD_PROGRESS: (uploadId: string) => `/api/mapa/upload-progress/${uploadId}`,
  MAPA_CLIENTES: '/api/mapa/clientes',
  MAPA_ESTATISTICAS: '/api/mapa/estatisticas',
  MAPA_LIMPAR: '/api/mapa/clientes',
  MAPA_ATUALIZAR_HIERARQUIA: '/api/mapa/atualizar-hierarquia',

  // Endpoints do Mapa - Ativas da Semana
  MAPA_ATIVAS: '/api/mapa/ativas',
  MAPA_ATIVAS_SYNC_STATUS: '/api/mapa/ativas/sync-status',
  MAPA_ATIVAS_SYNC_NOW: '/api/mapa/ativas/sync-now',
  MAPA_ATIVAS_GEOCODING_STATUS: '/api/mapa/ativas/geocoding-status',
  MAPA_ATIVAS_GEOCODING_RETRY: '/api/mapa/ativas/geocoding-retry',
  MAPA_ATIVAS_GEOCODING_ERRORS: '/api/mapa/ativas/geocoding-errors',
  MAPA_PREFERENCES: '/api/mapa/preferences',
  MAPA_ATIVAS_LIMPAR: '/api/mapa/ativas',
  MAPA_ATIVAS_SEMANAS: '/api/mapa/ativas/semanas',
  MAPA_ATIVAS_SEMANA: (semana: string) => `/api/mapa/ativas/semanas/${semana}`,
  MAPA_ATIVAS_DETALHE: (codigo: string) => `/api/mapa/ativas/${codigo}/detalhe`,
  MAPA_CADASTRO_UPDATE: (codigo: string) => `/api/mapa/cadastro/${codigo}`,

  // Endpoints do Mapa - Base Geral (Hierarquia)
  MAPA_BASE_GERAL_UPLOAD: '/api/mapa/base-geral/upload',
  MAPA_BASE_GERAL_STATS: '/api/mapa/base-geral/stats',
  MAPA_CLIENTES_POPULATE_HIERARQUIA: '/api/mapa/clientes/populate-hierarquia',
  MAPA_BASE_GERAL_DISTRITOS: '/api/mapa/base-geral/distritos',
  MAPA_BASE_GERAL_GRUPOS: '/api/mapa/base-geral/grupos',

  // Endpoints de Geocodificação em Lotes
  MAPA_GEOCODING_NEXT_BATCH: '/api/mapa/geocoding-next-batch',
  MAPA_GEOCODING_START: '/api/mapa/geocoding-start',
  MAPA_GEOCODING_STOP: '/api/mapa/geocoding-stop',
  MAPA_GEOCODING_STATUS: '/api/mapa/geocoding-status',

  // Endpoints de Controle de Uso Google Geocoding API
  GEOCODING_USAGE: '/api/mapa/geocoding-usage',
  GEOCODING_USAGE_HISTORY: '/api/mapa/geocoding-usage/history',
  GEOCODING_USAGE_ALERTS: '/api/mapa/geocoding-usage/alerts',
  GEOCODING_USAGE_ALERTS_MARK_READ: '/api/mapa/geocoding-usage/alerts/mark-read',
  GEOCODING_USAGE_LOG: '/api/mapa/geocoding-usage/log',
  GEOCODING_USAGE_CHECK: '/api/mapa/geocoding-usage/check',

  // Endpoints de Infraestrutura DB (Oracle)
  // Cobrança
  COBRANCA_DASHBOARD: '/api/cobranca/dashboard',
  COBRANCA_EFETIVIDADE: '/api/cobranca/efetividade',
  COBRANCA_CRM_PROJECT: '/api/cobranca/crm-project',
  COBRANCA_TEMPLATES: '/api/cobranca/templates',
  COBRANCA_TELEFONES: '/api/cobranca/telefones',
  COBRANCA_ENVIAR: '/api/cobranca/enviar',

  ORACLE_TEST_CONNECTION: '/api/oracle/test-connection',
  ORACLE_SCHEMAS: '/api/oracle/schemas',
  ORACLE_TABLES: '/api/oracle/tables',
  ORACLE_TABLE_COLUMNS: (schema: string, table: string) => `/api/oracle/table/${schema}/${table}/columns`,
  ORACLE_QUERY: '/api/oracle/query',
  ORACLE_QUERY_HISTORY: '/api/oracle/query-history',
  ORACLE_QUERY_HISTORY_USERS: '/api/oracle/query-history/users',
  ORACLE_AI_GENERATE: '/api/oracle/ai-generate',
  ORACLE_AI_REPORT: '/api/oracle/ai-report',
  ORACLE_REPORT_PDF: '/api/oracle/report-pdf',
  ORACLE_REPORT_JOBS: '/api/oracle/report-jobs',
  ORACLE_QUICK_COMMANDS: '/api/oracle/quick-commands',
  ORACLE_QUICK_COMMANDS_DETECT: '/api/oracle/quick-commands/detect-variables',
  ORACLE_DEEP_LEARN: '/api/oracle/deep-learn',
  ORACLE_LEARN_STATUS: '/api/oracle/learn-status',

  // Painel Tecnologia — monitoramento do servidor (host/gpu/docker + saúde do app)
  SYSTEM_METRICS: '/api/system/metrics',
  // Painel Tecnologia → aba Deploy — deriva Gitea × produção × dev das 3 stacks
  SYSTEM_DEPLOY: '/api/system/deploy',
  // Painel Tecnologia → aba Backup — snapshots restic + espelho no Drive
  SYSTEM_BACKUPS: '/api/system/backups',
  SYSTEM_BACKUPS_DOWNLOAD: '/api/system/backups/download',
  // Painel Tecnologia → aba Indicações — fila da PWA pública /indica?t=<token>
  INDICA_ADMIN_REFERRALS: '/api/indica/admin/referrals',
  INDICA_ADMIN_STATS: '/api/indica/admin/stats',
  INDICA_ADMIN_LINKS: '/api/indica/admin/links',
  INDICA_ADMIN_DESEMPENHO: '/api/indica/admin/desempenho',
  INDICA_ADMIN_VALORES: '/api/indica/admin/valores',
  // Painel Tecnologia → aba Arquivos — navegador dos shares (proxy admin → smb-gateway)
  FILES_LIST: '/api/files/list',
  FILES_SEARCH: '/api/files/search',
  FILES_DOWNLOAD: '/api/files/download',
  FILES_UPLOAD: '/api/files/upload',
  FILES_EDIT_CONFIG: '/api/files/edit-config',
  FILES_VERSIONS: '/api/files/versions',
  FILES_VERSION_CONTENT: '/api/files/version-content',
  FILES_RESTORE: '/api/files/restore',
  DOCS: '/api/docs',
  DOCS_DOWNLOAD: '/api/docs/download',
  DOCS_UPLOAD: '/api/docs/upload',
  // Painel Tecnologia — árvore da arquitetura (parseada de vault/conhecimento/arquitetura-sistema.md)
  SYSTEM_ARCHITECTURE: '/api/system/architecture',
  // Painel Tecnologia — chat com o agente Moss (proxy admin → stack moss-v2)
  MOSS_CHAT: '/api/moss/chat',
  MOSS_HEALTH: '/api/moss/health',
  // Painel Bloqueados — blocklist de contatos golpistas (admin). Bloquear aqui
  // emudece a Jú e tira o número do auto-assign de líder.
  BLOCKLIST: '/api/blocklist',
  BLOCKLIST_ITEM: (id: number) => `/api/blocklist/${id}`,
  // Remoção definitiva da lista (só entradas já desbloqueadas).
  BLOCKLIST_ITEM_PERMANENT: (id: number) => `/api/blocklist/${id}/permanent`,
  // Painel Bloqueados → aba Líderes — líderes que não recebem lead (admin).
  // Caso típico: pediu baixa e o DRACO ainda não baixou.
  LEADER_BLOCKLIST: '/api/leader-blocklist',
  LEADER_BLOCKLIST_ITEM: (id: number) => `/api/leader-blocklist/${id}`,
  LEADER_BLOCKLIST_ITEM_PERMANENT: (id: number) => `/api/leader-blocklist/${id}/permanent`,
  LEADER_BLOCKLIST_SEARCH: (q: string) => `/api/leader-blocklist/search?q=${encodeURIComponent(q)}`,
  // Transfere todos os leads pendentes de uma líder pra outra (admin).
  LEADER_TRANSFER_OPEN_LEADS: (code: string) => `/api/leaders/${encodeURIComponent(code)}/transfer-open-leads`,
  // Painel Tecnologia — toggle do auto-assign de líder fora do expediente (admin)
  AUTO_ASSIGN: '/api/admin/settings/auto-assign',
  // Painel Tecnologia — toggle do acompanhamento de líderes (nudge 12h + escala 24h)
  LEADER_FOLLOWUP: '/api/admin/settings/leader-followup',
  // Painel Tecnologia → Síntese de Voz (proxy admin → stack chatterbox-tts)
  TTS_INFO: '/api/tts/info',
  TTS_VOICES: '/api/tts/voices',
  TTS_GENERATE: '/api/tts/generate',
  TTS_NORMALIZE: '/api/tts/normalize', // normaliza texto pt-BR (IA) p/ TTS natural
  TTS_SAMPLE: '/api/tts/sample', // + /<Voz>.wav — amostra pt-BR pré-gerada
  TTS_CLONE_UPLOAD: '/api/tts/clone/upload',   // multipart 'audio' → staging
  TTS_CLONE_SAVE: '/api/tts/clone/save',       // {filename} → promove a voz
  TTS_CLONE_DISCARD: '/api/tts/clone/discard', // + /<arquivo> (DELETE)
  // Painel Tecnologia → Síntese de Voz (Qwen) — proxy admin → stack qwen3-tts
  QTTS_INFO: '/api/qtts/info',
  QTTS_GENERATE: '/api/qtts/generate',
  QTTS_CLONE: '/api/qtts/clone',
  QTTS_CLONE_UPLOAD: '/api/qtts/clone/upload',
  QTTS_CLONE_DISCARD: '/api/qtts/clone/discard',
  QTTS_SAMPLE: '/api/qtts/sample',
  // Painel Tecnologia → Síntese de Voz (OmniVoice) — proxy admin → stack omnivoice-tts
  OTTS_INFO: '/api/otts/info',
  OTTS_GENERATE: '/api/otts/generate',
  OTTS_CLONE: '/api/otts/clone',
  OTTS_CLONE_UPLOAD: '/api/otts/clone/upload',
  OTTS_CLONE_DISCARD: '/api/otts/clone/discard',
  OTTS_VOICES: '/api/otts/voices',          // listar vozes salvas
  OTTS_VOICE_SAVE: '/api/otts/voices/save', // salvar voz clonada (label + ref_text)
  OTTS_KEY: '/api/otts/key',                // chave Bearer atual da API pública (tts.twms.com.br)
  OTTS_KEY_ROTATE: '/api/otts/key/rotate',  // gera nova chave Bearer (rotaciona)
  // Painel Tecnologia → Transcrição (Whisper self-hosted) — proxy admin → stack whisper
  WHISPER_INFO: '/api/whisper/info',
  WHISPER_TRANSCRIBE: '/api/whisper/transcribe', // multipart 'audio' → texto
  WHISPER_ANALYZE: '/api/whisper/analyze',       // multipart 'audio' → {rawText,segments}
  WHISPER_KEY: '/api/whisper/key',               // chave Bearer da API pública (whisper.twms.com.br)
  WHISPER_KEY_ROTATE: '/api/whisper/key/rotate', // rotaciona

  // Marketing Panel
  MARKETING_AI_CHAT: '/api/marketing/ai-chat',
  AGENTE_LIMITE: '/api/marketing/agente/limite',
  AGENTE_CHATS: '/api/marketing/agente/chats',
  AGENTE_CHAT: (id: string) => `/api/marketing/agente/chats/${id}`,
  AGENTE_TURNO: (id: string) => `/api/marketing/agente/chats/${id}/turno`,
  AGENTE_ANEXO: (id: string) => `/api/marketing/agente/chats/${id}/anexo`,
  AGENTE_ANEXO_ITEM: (id: string, anexoId: string) => `/api/marketing/agente/chats/${id}/anexo/${anexoId}`,
  AGENTE_ANEXO_CSV: (id: string, anexoId: string) => `/api/marketing/agente/chats/${id}/anexo/${anexoId}/csv`,
  AGENTE_TEMPLATE: (id: string) => `/api/marketing/agente/chats/${id}/template`,
  AGENTE_TEMPLATE_CONFIRMAR: (id: string) => `/api/marketing/agente/chats/${id}/template/confirmar`,
  AGENTE_TEMPLATE_STATUS: (id: string) => `/api/marketing/agente/chats/${id}/template/status`,
  AGENTE_TESTE: (id: string) => `/api/marketing/agente/chats/${id}/teste`,
  AGENTE_PREVIA: (id: string) => `/api/marketing/agente/chats/${id}/previa`,
  AGENTE_DISPARO: (id: string) => `/api/marketing/agente/chats/${id}/disparo`,
  AGENTE_DISPARAR: (id: string) => `/api/marketing/agente/chats/${id}/disparar`,
  MARKETING_TEMPLATES: '/api/marketing/templates',
  MARKETING_TEMPLATES_SYNC: '/api/marketing/templates/sync',
  MARKETING_TEMPLATES_CREATE: '/api/marketing/templates/create',
  MARKETING_AUDIENCE_UPLOAD: '/api/marketing/audience/upload',
  MARKETING_AUDIENCE_SMART_MAPPING: '/api/marketing/audience/smart-mapping',
  MARKETING_AUDIENCES: '/api/marketing/audiences',
  MARKETING_CAMPAIGN_EXECUTE: '/api/marketing/campaign/execute',
  MARKETING_CAMPAIGNS: '/api/marketing/campaigns',
  MARKETING_SESSIONS: '/api/marketing/sessions',
  MARKETING_SESSION_MESSAGES: (id: string) => `/api/marketing/sessions/${id}/messages`,

  // Landing de captação (/consultora) — o GET é público e a própria landing
  // chama com fetch cru; estes aqui são usados pelo editor no painel Captação.
  LANDING_CONFIG: '/api/landing/captacao',
  LANDING_UPLOAD: '/api/landing/upload',
  // Qual renderizador a página pública usa: 'v1' (blocos fixos) ou 'v2' (Puck).
  // É o interruptor de virada e de volta atrás da migração do editor visual.
  LANDING_MOTOR: '/api/landing/motor',
} as const